import './styles.scss'
import React, { useState } from 'react'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'primereact/dropdown'
import { Dialog } from 'primereact/dialog'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { getLocalUserDetails } from 'Utils/LocalStorageHandler'
import { ButtonComponent } from 'Components/UIComponents'
import apiAdapterCoffeeWeb from 'Services/apiAdapterCoffeeWeb'
import Loader from 'Components/Loader'

const GlobalDifferentialExcelUpload = ({ setLoading, ...props }) => {
  const { xlData, setXlData, selectedCountry, countryList, setShowDifferentialPreviewDailogModal, setModalState } = props

  const { t } = useTranslation()

  const [dataEdited, setDataEdited] = useState(false)
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false)

  const cropYearBodyTemplate = (rowData, column) => {
    if (rowData.isCropYear && column.rowIndex === xlData.length - 1) {
      return <InputText type="text" value={rowData[column.field]} onBlur={(e) => handleCropYearBlur(e, rowData)} onChange={(e) => onCropYearChange(e, rowData, column)} autoFocus />
    }

    return rowData[column.field]
  }

  const divWithData = (rowData) => <div>{rowData.CropYear}</div>

  const columns = [
    { className: 'rowReorder', rowReorder: true },
    { field: 'CountryName', header: t('COUNTRY_NAME'), className: 'countryName' },
    { field: 'CropYear', header: t('CROP_YEAR'), className: 'cropYear', body: dataEdited ? divWithData : cropYearBodyTemplate },
    { field: 'QualityName', header: t('QUALITY_NAME'), className: 'qualityName' },
    { field: 'Quality', header: t('QUALITY'), className: 'quality' },
    { field: 'QualitySpecification', header: t('QUALITY_SPECIFICATION'), className: 'qualitySpecification' },
    { field: 'QualityCode', header: t('QUALITY_CODE'), className: 'qualityCode' },
    { field: 'UpdatedDate', header: t('UPDATED_DATE'), className: 'UpdatedDate' },
    { field: 'Terminal', header: t('TERMINAL'), className: 'termial' },
    { field: 'TerminalLevel', header: t('TERMINAL_LEVEL'), className: 'termialLevel' },
    { field: 'RangeStart', header: t('RANGE_STARTS'), className: 'rangeStart' },
    { field: 'RangeEnd', header: t('RANGE_ENDS'), className: 'rangeEnd' },
    { field: 'Remark', header: t('REMARK'), className: 'remark' },
    { field: 'QualityGroup', header: t('QUALITY_GROUP'), className: 'qualityGroup' },
    { field: 'Moisture', header: t('MOISTURE'), className: 'moisture' },
    { field: 'ScreenRetention', header: t('SCREEN_RETENTION'), className: 'screenRetention' },
    { field: 'Defects', header: t('DEFECTS'), className: 'defects' },
    { field: 'FobPort', header: t('FOB_PORT'), className: 'fobPort' },
    { field: 'ForexValue', header: t('FOREX_VALUE'), className: 'forexValue' },
    { field: 'ForexType', header: t('FOREX_TYPE'), className: 'forexType' }
  ]

  const countryName = (options) => {
    const defaultCountry = countryList.find((ele) => {
      if (ele.nicename === options.rowData.CountryName) {
        return ele
      }
    })

    return <Dropdown value={defaultCountry} options={countryList} onChange={(e) => handleChangeCountry(e, options)} optionLabel="nicename" placeholder="Select a City" />
  }

  const addRowForGlobalDifferentials = () => {
    const newObject = {
      CountryName: 'India',
      CropYear: '',
      isCropYear: true,
      Defects: '',
      Moisture: '',
      QualityCode: '',
      UpdatedDate: '',
      Terminal: '',
      TerminalLevel: '',
      QualityGroup: '',
      QualityName: '',
      Quality: '',
      QualitySpecification: '',
      RangeEnd: '',
      RangeStart: '',
      Remark: '',
      ScreenRetention: '',
      FobPort: '',
      ForexValue: '',
      ForexType: ''
    }

    setIsSubmitButtonDisabled(true)
    setXlData([...xlData, newObject])
  }

  const deleteRow = (options) => {
    setModalState({
      showModal: true,
      message: t('ARE_YOU_SURE_WANT_TO_DELETE_THIS_ROW'),
      modalType: 'info',
      confirmAction: () => confirmDeleteRow(options.rowIndex)
    })
  }

  const handleChangeCountry = (e, options) => {
    const { id } = e.target.value
    const findCountry = countryList.find((ele) => ele.id === id)
    const modifiedData = xlData.map((ele, index) => {
      if (options.rowIndex === index) {
        return {
          ...ele,
          [options.field]: findCountry.nicename
        }
      }

      return ele
    })

    setXlData(modifiedData)
  }

  const onInputBlur = (options) => {
    const modifiedData = xlData.map((ele, index) => (options.rowIndex === index ? { ...ele, [options.field]: options.value } : ele))

    setXlData(modifiedData)
  }

  const cellEditor = (options) => {
    if (options.field === 'CountryName') return countryName(options)

    return textEditor(options)
  }

  const textEditor = (options) => {
    const { CountryName, CropYear, Defects, Moisture, QualityCode, QualityGroup, QualityName, Quality, QualitySpecification, UpdatedDate, Terminal, TerminalLevel, RangeEnd, RangeStart, Remark, ScreenRetention, FobPort, ForexValue, ForexType } = options.rowData

    if (!CountryName || !CropYear || !Defects || !Moisture || !QualityCode || !QualityGroup || !UpdatedDate || !Terminal || !TerminalLevel || !QualityName || !Quality || !RangeEnd || !RangeStart || !Remark || !ScreenRetention || !FobPort || !ForexValue || !ForexType) {
      setIsSubmitButtonDisabled(true)
    } else {
      setIsSubmitButtonDisabled(false)
    }

    if (options.rowData) return <InputText type="text" value={options.value} onBlur={() => onInputBlur(options)} onChange={(e) => options.editorCallback(e.target.value)} />
  }

  const confirmDeleteRow = (itemIndex) => {
    const updatedData = xlData.filter((ele, index) => index !== itemIndex)

    setXlData(updatedData)
    setModalState({ showModal: false })
  }

  const onCropYearChange = (e, rowData) => {
    const updatedData = xlData?.map((dataItem) => {
      if (dataItem === rowData) {
        return { ...dataItem, CropYear: e.target.value }
      }

      return dataItem
    })

    setXlData(updatedData)
  }

  const handleCropYearBlur = (e, rowData) => {
    setDataEdited(true)
    divWithData(rowData)
  }

  const uploadGlobalDifferentialData = async () => {
    setLoading(true)
    try {
      const { id: idUser } = getLocalUserDetails()
      const postData = xlData.map((xlItem) => {
        const { CountryName, QualityName, Quality, QualitySpecification, QualityCode, UpdatedDate, Terminal, TerminalLevel, RangeStart, RangeEnd, Remark, QualityGroup, Moisture, ScreenRetention, Defects, CropYear, FobPort, ForexValue, ForexType } = xlItem

        return {
          id: 0,
          idUser,
          idCountry: selectedCountry.id,
          countryName: CountryName,
          qualityName: QualityName?.toString(),
          quality: Quality?.toString(),
          qualitySpecification: (QualitySpecification ?? '')?.toString(),
          qualityCode: QualityCode?.toString(),
          updatedDate: UpdatedDate?.toString(),
          terminal: Terminal?.toString(),
          terminalLevel: TerminalLevel?.toString(),
          rangeStart: RangeStart?.toString(),
          rangeEnd: RangeEnd?.toString(),
          remark: Remark?.toString(),
          qualityGroup: QualityGroup?.toString(),
          moisture: Moisture?.toString(),
          screenRetention: ScreenRetention?.toString(),
          defects: Defects?.toString(),
          cropFor: CropYear?.toString(),
          orderBy: 0,
          fobPort: FobPort?.toString(),
          forexValue: ForexValue?.toString(),
          forexType: ForexType?.toString()
        }
      })

      const response = await apiAdapterCoffeeWeb.postInsertGlobalDifferentialAdmin(postData)

      if (response.data === true) {
        setModalState({
          showModal: true,
          message: t('EXCEL_DATA_ADDED_SUCCESSFULLY'),
          modalType: 'success'
        })
      } else {
        setModalState({
          showModal: true,
          message: t('SOMETHING_WENT_WRONG'),
          modalType: 'error'
        })
      }
    } catch {
      setModalState({
        showModal: true,
        message: t('FAILED_TO_ADD_GLOBAL_DIFFERENTIALS'),
        modalType: 'error'
      })
    } finally {
      setLoading(false)
    }
  }

  const footerContent = <ButtonComponent type="custom" label="SUBMIT" variant="action" onClick={() => uploadGlobalDifferentialData()} disabled={xlData?.length === 0 || isSubmitButtonDisabled} />

  return (
    <Dialog className="global-differential-data-preview-modal-popup" header="Global Differentials" visible={true} style={{ width: '95vw', height: '100vh' }} onHide={() => setShowDifferentialPreviewDailogModal(false)} footer={footerContent}>
      <div className="add-button-wrapper">
        <ButtonComponent type="custom" label="ADD" variant="action" icon="pi pi-plus" onClick={() => addRowForGlobalDifferentials()} />
      </div>

      <div className="preview-table-wrapper">
        <DataTable className="card" scrollable scrollHeight="60vh" reorderableRows onRowReorder={(e) => setXlData(e.value)} value={xlData} editMode="cell" tableStyle={{ minWidth: '50rem' }}>
          {columns.map(({ field, header, className, rowReorder, body }, index) => (
            <Column key={index} field={field} header={header} rowReorder={rowReorder} className={className} body={body} editor={(options) => cellEditor(options)} />
          ))}
          <Column body={(_, options) => <Button icon="pi pi-trash" onClick={() => deleteRow(options)} />} />
        </DataTable>
      </div>
    </Dialog>
  )
}

export default Loader(GlobalDifferentialExcelUpload)
